import { Restaurant } from "../model-restaurant";

const client = require('api/auth')

declare const PAYMENTS_SVC_API2: string

export interface Subscription {
  id: number
}

export interface Plan {
  value: { context: Context; variables: Variables[] }[]
}

interface Context {
  type: string
}

interface Variables {
  name: string
  value: number
  type: string
}
export interface Script {
  id: null | number
}

export type BillingPayloadType =
  | 'delivery order payment'
  | 'pickup order payment'
  | 'dinein order payment'
  | 'curbside order payment'
  | 'delivery order'
  | 'pickup order'
  | 'dinein order'
  | 'curbside order'
  | 'fax notification'
  | 'ivr call'
  | 'sms notification'
  | 'email notification'
  | 'phone notification'
  | 'platform fees'
  | 'payment out'
  | 'payment in'
  | 'delivery failure'
  | 'platform failure'
  | 'google matrix'
  | 'external delivery order'
  | 'growth services'
  | 'statement_fee'
  | 'ach_failure_fee'
  | 'manual adjustment'

export type ContextType =
  | 'tender'
  | 'channel_tender'
  | 'restaurant'
  | 'channel'
  | 'subscription'
  | 'loyalty'
  | 'charge'
  | 'ambassador'
  | 'service_provider'
  | 'discount'
  | 'rds'
  | 'invoicer_settings'

export type payload_type = BillingPayloadType
type money_flow_type = ContextType // 'subscription' | 'restaurant' | 'channel' | 'brand'

export type Source = 'total' | 'subtotal' | 'tip' | 'tax' | 'delivery' | 'service' | 'discount' | string
export type Count = 'order' | 'page' | 'second' | 'minute' | 'day' | 'sms' | string

export type OwnerType =
  | 'restaurant'
  | 'customer'
  | 'ambassador'
  | 'zuppler'
  | 'service_provider'
  | 'subscription'
  | 'channel'
  | 'rds'
  | 'tender'
  | 'invoicer_settings'

export type AccountType = 'principal' | 'balance'

export interface BillingScript {
  id: number
  owner_type: string
  owner_id: number
  script: string
  content: BillingScriptContent
  inserted_at: string
  updated_at: string
}

export interface BillingScriptContent {
  context: { type: money_flow_type }
  variables: ScriptVariables[]
  rule_set: RuleSet[]
}

export interface ScriptTender {
  id: number
  gateway: string
  type: string
  label: string
  business_account: 'restaurant' | 'merchant' | 'subscription'
  inline: boolean
  settings: any
  merchant: null | {
    type: AccountType
    owner_type: OwnerType // 'restaurant' | 'service_provider'
    name: string // Valid only when direct & service_provider    
  }
  rules: ScriptRule[]
  applies_to: null | BillingPayloadType
}

export interface RuleSet {
  applies_to: BillingPayloadType[]
  rules: ScriptRule[]
  tenders: ScriptTender[]
}

export interface ScriptRule {
  name: string
  value: any
  billing_script_id: number
  context_id: number
  context_type: string
  restaurant_id: number
  dst_name: string
  percent: PercentScriptValue<Source> | null
  fixed: FixedScriptValue<Count> | null
  debit: ScriptAccount
  credit: ScriptAccount
  overrides: RuleOverride[]
}

export interface PercentScriptValue<Src> {
  value: {
    op: 'percent'
    type: 'lookup' | 'const'
    name: null | string // Only valid for type lookup
    value: number
  }
  source: Src
}

export interface FixedScriptValue<Src> {
  value: {
    op: 'fixed'
    type: 'lookup' | 'const'
    name: null | string // Only valid for type lookup
    value: number
  }
  count: Src
}


export interface ScriptAccount {
  type: 'lookup' | 'direct'
  owner_type: 'restaurant' | 'subscription' | 'service_provider' | 'rds' | 'customer'
  account_type: 'balance' | 'principal'
  name: null | string // Only valid for type direct
}

export interface RuleOverride {
  type: ContextType
  name: string
  percent: {
    op: 'percent'
    type: 'lookup' | 'const'
    name: null | string // Only valid for type lookup
    value: number
  }
  fixed: {
    op: 'fixed'
    type: 'lookup' | 'const'
    name: null | string // Only valid for type lookup
    value: number
  }
}

export interface ScriptVariables {
  type: 'const' | 'lookup'
  value: number
  name: string
  op: 'percent' | 'fixed'
}

export interface Pagination {
  page: number
  per_page: number
  total: number
  pages: number
}

export function loadSubscriptionBillingPlan(restaurant: Restaurant): Promise<BillingScript> {
  const token = client.getAuthResponse() ? client.getAuthResponse().access_token : null

  return fetch(`${PAYMENTS_SVC_API2}/v5/billing_scripts/search`, {
    method: 'POST',
    headers: authorize(token),
    body: JSON.stringify({
      owner_id: restaurant.subscription_id,
      owner_type: 'subscription',
      page: 1,
      per_page: 10
    })
  }).then(res => res.ok ? res.json() : res.json().then(err => Promise.reject(err)))
    .then(({ pagination, data }) =>
      pagination.total > 0
        ? Promise.resolve(data[0])
        : Promise.reject({ message: "No billing plan found for this subscription" }))
}

function authorize(token: string) {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
}
